<!-- TODO CV-LAYOUT Prüfen ob hier das selbe Overlay wie in Kiosk genutzt wird -->

@if (loading$ | async) {
    <div
        class="loading-overlay"
        data-testid="t-loading-overlay-div-1752672977568-6"
    >
        <div
            class="app-splash-screen"
            data-testid="t-loading-overlay-div-1752672977568-5"
        >
            <div
                class="loading-container"
                data-testid="t-loading-overlay-div-1752672977568-4"
            >
                <div
                    class="circle circle1"
                    data-testid="t-loading-overlay-div-1752672977568-1"
                ></div>
                <div
                    class="circle circle2"
                    data-testid="t-loading-overlay-div-1752672977568-2"
                ></div>
                <div
                    class="circle circle3"
                    data-testid="t-loading-overlay-div-1752672977568-3"
                ></div>
            </div>
        </div>
    </div>
}
